function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _g;
var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};
var SvgWorkshop = function SvgWorkshop(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '35px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '35px' : _ref$height,
    originalSize = _ref.originalSize,
    top = _ref.top,
    bottom = _ref.bottom,
    left = _ref.left,
    right = _ref.right,
    rest = _objectWithoutProperties(_ref, _excluded);
  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.603 22.506 3.863 38.312a2 2 0 0 0 .1 2.827l3.656 3.41a2 2 0 0 0 2.827-.099l11.912-12.774m9.085-9.742c.188-.203.472-.506.85-.911a9.054 9.054 0 0 0 8.883-2.6 9.055 9.055 0 0 0 1.639-9.9l-5.102 5.47a1.003 1.003 0 0 1-1.415.046l-3.812-3.554a1.004 1.004 0 0 1-.053-1.415l5.019-5.383a9.055 9.055 0 0 0-9.477 2.426 9.053 9.053 0 0 0-2.108 8.603l-3.583 3.843"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m22.014 28.178 6.252-6.474 17.577 16.974-6.252 6.474z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20.638 24.346 3.75-3.885 2.628 2.537-3.751 3.885zM11.912 8.032 8.11 11.97 3.405 4.887l1.29-1.336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.558 22.447 9.85 10.225"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 38.972,
    r: 1,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m26 28 13.278 12.585M28 26l13.278 12.585"
  }))));
};
export { SvgWorkshop as ReactComponent };
export default "/_next/static/media/workshop.80fdbdb3.svg";